import update from 'immutability-helper'

import * as actions from '../../actions/actions'

const initialState = {
  corporateToEdit: {
    corporateSenderId: '',
    corporateSenderName: '',
    enabled: false,
    bank: '',
    contiCorrenti: [],
    logo:'',
    autoAccept:'',
    timeToExpiry:'',
    daysToFirstReminder:'',
    daysToSecondReminder:'',
    whatsapp:'',
    primaryColor:'',
    secondaryColor:'',
    hasBankAuthorizer:false
  },
  noAuthorizer:false,
  error: ''
}

export default function corporateEdit(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_CORPORATE_EDIT_SUCCESS:
      return fetchCorporateEditSuccess(state, action)
    case actions.FETCH_CORPORATE_EDIT_FAILURE:
      return fetchCorporateEditFailure(state, action)
    case actions.EDIT_CORPORATE_CORPORATE_SENDER_ID_FIELD_CHANGE:
      return editCorporateCorporateSenderIdFieldChange(state, action)
    case actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_ENABLE_CHANGE:
      return editCorporateCorporateHasBankAuthorizerFieldEnableChange(state, action)
    case actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_DISABLE_CHANGE:
      return editCorporateCorporateHasBankAuthorizerFieldDisableChange(state, action)
    case actions.EDIT_CORPORATE_CORPORATE_HAS_BANK_AUTHORIZER_EXISTS:
      return editCorporateCorporateHasBankAuthorizerExists(state, action)
    case actions.EDIT_CORPORATE_CORPORATE_WHATSAPP_FIELD_CHANGE:
      return editCorporateCorporateWhatsappFieldChange(state, action)
    case actions.EDIT_CORPORATE_CORPORATE_DAYS_TO_FIRST_REMINDER_FIELD_CHANGE:
      return editCorporateCorporateDaysToFirstReminderFieldChange(state, action)
    case actions.EDIT_CORPORATE_CORPORATE_DAYS_TO_SECOND_REMINDER_FIELD_CHANGE:
      return editCorporateCorporateDaysToSecondReminderFieldChange(state, action)
    case actions.EDIT_CORPORATE_CORPORATE_AUTOACCEPT_FIELD_CHANGE:
      return editCorporateCorporateAutoAcceptFieldChange(state, action)
    case actions.EDIT_CORPORATE_CORPORATE_TIME_TO_EXPIRE_FIELD_CHANGE:
      return editCorporateCorporateTimeToExpireFieldChange(state, action)
    case actions.EDIT_CORPORATE_CORPORATE_SENDER_NAME_FIELD_CHANGE:
      return editCorporateCorporateSenderNameFieldChange(state, action)
    case actions.EDIT_CORPORATE_ENABLED_FILED_CHANGE:
      return editCorporateEnabledFieldChange(state, action)
    case actions.EDIT_CORPORATE_ID_BANK_FIELD_CHANGE:
      return editCorporateIdBankFieldChange(state, action)
    case actions.EDIT_CORPORATE_CLEAN:
      return editCorporateClean(state, action)
    case actions.UPDATE_CORPORATE_EDIT_FAILURE:
      return updateCorporateError(state,action)
    case actions.EDIT_CORPORATE_CORPORATE_LOGO_FILED_CHANGE:
      return editCorporateCorporateLogoFieldChange(state, action)
    case actions.CORPORATE_PRIMARY_COLOR_CHANGE:
      return editCorporatePrimaryColorChange(state,action)
    case actions.CORPORATE_SECONDARY_COLOR_CHANGE:
      return editCorporateSecondaryColorChange(state,action)
    default:
      return state
  }
}


const updateCorporateError = (state,action) => {
  return {
    ...state,
    error: action.error
  }
}

const editCorporateCorporateLogoFieldChange = (state, action) => {
  return update(
    state,
    {corporateToEdit: {logo: {$set: action.value}}}
  )
}

const fetchCorporateEditSuccess = (state, action) => {
  return {
    ...state,
    corporateToEdit: action.value
  }
}

const fetchCorporateEditFailure = (state, action) => {
  return {
    ...state,
    error: action.value
  }
}

const editCorporateCorporateSenderIdFieldChange = (state, action) => {
  return update(
    state,
    {corporateToEdit: {corporateSenderId: {$set: action.value}}}
  )
}

const editCorporateCorporateWhatsappFieldChange = (state, action) => {
  return update(
      state,
      {corporateToEdit: {whatsapp: {$set: action.value}}}
  )
}

const editCorporateCorporateAutoAcceptFieldChange = (state, action) => {
  return update(
      state,
      {corporateToEdit: {autoAccept: {$set: action.value}}}
  )
}

const editCorporateCorporateTimeToExpireFieldChange = (state, action) => {
  return update(
      state,
      {corporateToEdit: {timeToExpiry: {$set: action.value}}}
  )
}

const editCorporateCorporateDaysToFirstReminderFieldChange = (state, action) => {
  return update(
      state,
      {corporateToEdit: {daysToFirstReminder: {$set: action.value}}}
  )
}
const editCorporateCorporateDaysToSecondReminderFieldChange = (state, action) => {
  return update(
      state,
      {corporateToEdit: {daysToSecondReminder: {$set: action.value}}}
  )
}


const editCorporateCorporateSenderNameFieldChange = (state, action) => {
  return update(
    state,
    {corporateToEdit: {corporateSenderName: {$set: action.value}}}
  )
}

const editCorporateEnabledFieldChange = (state, action) => {
  return update(
    state,
    {corporateToEdit: {enabled: {$set: action.value}}}
  )
}

const editCorporateIdBankFieldChange = (state, action) => {
  return update(
    state,
    {corporateToEdit: {bank: {$set: action.value}}}
  )
}

const editCorporateClean = (state, action) => {
  return initialState;
}

const editCorporatePrimaryColorChange = (state, action) => {
  return update(
    state,
    {corporateToEdit: {primaryColor: {$set: action.value}}}
  )
}

const editCorporateSecondaryColorChange = (state, action) => {
  return update(
    state,
    {corporateToEdit: {secondaryColor: {$set: action.value}}}
  )
}

const editCorporateCorporateHasBankAuthorizerFieldEnableChange = (state, action) => {

  return update(
      state,
      {corporateToEdit: {hasBankAuthorizer: {$set: action.value}}}
  )
}


const editCorporateCorporateHasBankAuthorizerFieldDisableChange = (state, action) => {
  return update(
      state,
      {corporateToEdit: {hasBankAuthorizer: {$set: action.value}}}
  )
}
const editCorporateCorporateHasBankAuthorizerExists = (state, action) => {
  return update(
      state,
      {noAuthorizer: {$set: action.value}}
  )
}